// Route path constants
export const ROUTE_LOGIN = '/login';
export const TERMS_OF_SERVICE_URL = 'https://gmgcolor.com/terms-conditions';
export const SUPPORT_URL = 'https://gmgcolor.com/support';

export const ROUTE_HOME = '/';
export const ROUTE_JOBS = '/jobs';
export const ROUTE_PRINTERS = '/printers';
export const ROUTE_SYSTEMS = '/systems';
export const ROUTE_FLOWS = '/flows';
export const ROUTE_COLORCARD = '/colorcard';

export const AUTH_ROUTES = [ROUTE_HOME, ROUTE_LOGIN];
export const APP_JOBS_ROUTES = [ROUTE_JOBS];

export const JOBS = 0;
export const PRINTERS = 1;
export const SYSTEMS = 2;
export const FLOWS = 3;
export const NOT_FOUND = 4;
export const NAVIGATION_INDEXES = [JOBS, PRINTERS, SYSTEMS, FLOWS, NOT_FOUND] as const;
export type NAVIGATION_INDEXES_TYPE = typeof NAVIGATION_INDEXES[number];
